import { CalculosApi } from '@common/api';
const CertificadoInternoService = {
  voltarAndamento: function (id) {
    return CalculosApi.patch()(`/certificado/${id}/voltar-em-andamento`);
  }
};

export default CertificadoInternoService;
